import './App.css';
import MyNavbar from './MyNavbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import DeckCmpPage from './DeckCmpPage';

function App() {
  return ( <>
    <MyNavbar/>
    <DeckCmpPage/>
    </>
  );
}

export default App;
